// extracted by mini-css-extract-plugin
module.exports = {"prose":"prose_prose__BF0Lc"};